import { useMutation } from '@tanstack/react-query';
import { postProjectLike } from '@src/apis/index';

export const usePostProjectLike = (projectId: string) =>
  useMutation({ mutationKey: ['postProjectLike', projectId], mutationFn: () => postProjectLike(projectId) });
